import React from 'react'; // eslint-disable-line

import { Divider, Grid, Paper, Typography, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { OpenModal, openModalAction } from '../../../../form-modal/actions';
import { formatCurrency, parsStringToDate } from '../../../../shared-functions';
import styles, { StyledComponent } from '../../../../styles/styles';
import { LabeledValue } from '../../../../controls/labeled-value';
import { State } from '../../../../redux/root-reducer';
import { ClaimType } from '../../../../claim/claim-types';
import {
    getDeathAssessmentDetails,
    RiskPolicyAssessmentDetails,
} from '../../../decisions/death/death-assessment-details-reducer';
import { Bonus } from '../../../decisions/assessment-details-reducer';
interface OwnProps {
    contractIndex: number;
    claimType: ClaimType;
}

type Props = StyledComponent &
    OwnProps & {
        contractIndex: number;
        openModal: OpenModal;
        riskPolicyAssessmentDetails?: RiskPolicyAssessmentDetails[];
    };
const deathBenefitBonusDetails: React.FunctionComponent<Props> = ({
    classes,
    riskPolicyAssessmentDetails,
}: Props) => {
    const benefitBonus =
        riskPolicyAssessmentDetails && riskPolicyAssessmentDetails.find(c => c.bonus !== null);

    if (!benefitBonus) {
        return null;
    }
    if (
        benefitBonus?.bonus?.addlibBonusInd === 'N' &&
        benefitBonus?.bonus?.wellnessBonusIndPla === 'N' &&
        benefitBonus?.bonus?.eduXtraBonusIndPla === 'N'
    ) {
        return null;
    }

    return (
        <React.Fragment>
            <Grid container justify="space-between">
                <Grid item xs={10} lg={11} className={classes.marginTop}>
                    <Typography variant="subtitle2">BONUS & BENEFIT FLAGS</Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                {riskPolicyAssessmentDetails &&
                    riskPolicyAssessmentDetails.map((benefit, index) => {
                        return (
                            <Grid container justify="flex-start" key={index}>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.marginTop}>
                                        WELLNESS BONUS
                                    </Typography>
                                </Grid>
                                {benefit.bonus && benefit.bonus.wellnessBonusesPla && (
                                    <Grid item xs={4} lg={6}>
                                        <Typography
                                            variant="subtitle2"
                                            className={classes.marginTop}
                                        >
                                            Wellness Bonus PLA
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.wellnessBonusesSla && (
                                    <Grid item xs={6} lg={6}>
                                        <Typography
                                            variant="subtitle2"
                                            style={{ marginLeft: '2%' }}
                                            className={classes.marginTop}
                                        >
                                            Wellness Bonus SLA
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.wellnessBonusesPla && (
                                    <WellnessBonusView bonus={benefit.bonus} classes={classes} />
                                )}
                                {benefit.bonus && benefit.bonus.wellnessBonusesPla && (
                                    <Grid item xs={4} lg={3}>
                                        <Typography
                                            variant="subtitle2"
                                            className={classes.marginTop}
                                        >
                                            Total Bonus Amount (PLA)
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.wellnessBonusesPla && (
                                    <Grid item xs={4} lg={3}>
                                        <Typography
                                            variant="subtitle2"
                                            style={{ marginLeft: '3%' }}
                                            className={classes.marginTop}
                                        >
                                            {formatCurrency(
                                                benefit.bonus?.wellnessBonusTotalAmountPla
                                            )}
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.wellnessBonusesSla && (
                                    <Grid item xs={5} lg={3}>
                                        <Typography
                                            variant="subtitle2"
                                            style={{ marginLeft: '4%' }}
                                            className={classes.marginTop}
                                        >
                                            Total Bonus Amount (SLA)
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.wellnessBonusesSla && (
                                    <Grid item xs={3} lg={3}>
                                        <Typography
                                            variant="subtitle2"
                                            style={{ marginLeft: '5%' }}
                                            className={classes.marginTop}
                                        >
                                            {formatCurrency(
                                                benefit.bonus?.wellnessBonusTotalAmountSla
                                            )}
                                        </Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Divider
                                        className={classNames(
                                            classes.marginTop,
                                            classes.marginBottom
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2" className={classes.marginTop}>
                                        ADDLIB BONUS
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} lg={6}>
                                    <Typography variant="subtitle2" className={classes.marginTop}>
                                        AddLib Bonus PLA
                                    </Typography>
                                </Grid>

                                <Grid item xs={6} lg={6}>
                                    <Typography variant="subtitle2" className={classes.marginTop}>
                                        AddLib Bonus SLA
                                    </Typography>
                                </Grid>
                                <Grid item xs={3} lg={3}>
                                    {benefit.bonus && (
                                        <LabeledValue
                                            label="Due Date"
                                            value={parsStringToDate(
                                                benefit.bonus.addlibBonusDueDate
                                            )}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={3} lg={3}>
                                    <LabeledValue
                                        label="Amount"
                                        value={formatCurrency(benefit.bonus?.addlibBonusAmount)}
                                    />
                                </Grid>
                                <Grid item xs={3} lg={3}>
                                    <LabeledValue label="Due Date" />
                                </Grid>
                                <Grid item xs={3} lg={3}>
                                    <LabeledValue label="Amount" />
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider
                                        className={classNames(
                                            classes.marginTop,
                                            classes.marginBottom
                                        )}
                                    />
                                </Grid>
                                {benefit.bonus && benefit.bonus.eduXtraBonusAmountPla && (
                                    <Grid item xs={12}>
                                        <Typography
                                            variant="subtitle2"
                                            className={classes.marginTop}
                                        >
                                            EDUXTRA BONUS
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.eduXtraBonusIndPla === 'Y' && (
                                    <Grid item xs={4} lg={6}>
                                        <Typography
                                            variant="subtitle2"
                                            className={classes.marginTop}
                                        >
                                            EduXtra Bonus PLA
                                        </Typography>
                                    </Grid>
                                )}
                                {benefit.bonus && benefit.bonus.eduXtraBonusIndSla === 'Y' && (
                                    <Grid item xs={6} lg={6}>
                                        <Typography
                                            variant="subtitle2"
                                            className={classes.marginTop}
                                        >
                                            EduXtra Bonus SLA
                                        </Typography>
                                    </Grid>
                                )}
                                <Grid item xs={12}>
                                    <Typography variant="subtitle2">{}</Typography>
                                </Grid>
                                {benefit.bonus && benefit.bonus.eduXtraBonusAmountPla && (
                                    <>
                                        <Grid item xs={4} lg={3}>
                                            <LabeledValue
                                                label="Due Date"
                                                value={parsStringToDate(
                                                    benefit.bonus?.eduXtraBonusDueDatePla
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={6} lg={3}>
                                            <LabeledValue
                                                label="Amount"
                                                value={formatCurrency(
                                                    benefit.bonus?.eduXtraBonusAmountPla
                                                )}
                                            />
                                        </Grid>
                                    </>
                                )}
                                {benefit.bonus &&
                                    benefit.bonus.eduXtraBonusAmountSla &&
                                    benefit.bonus?.eduXtraBonusDueDateSla && (
                                        <>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Due Date"
                                                    value={parsStringToDate(
                                                        benefit.bonus?.eduXtraBonusDueDateSla
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Amount"
                                                    value={formatCurrency(
                                                        benefit.bonus?.eduXtraBonusAmountSla
                                                    )}
                                                />
                                            </Grid>
                                        </>
                                    )}
                            </Grid>
                        );
                    })}
            </Paper>
        </React.Fragment>
    );
};

type Prop = StyledComponent & {
    bonus?: Bonus;
};
const WellnessBonusView = ({ bonus, classes }: Prop) => {
    if (bonus === null) {
        return null;
    }
    return (
        <React.Fragment>
            <Typography variant="h5" className={classes.spacedTypography}></Typography>

            <Grid container spacing={5}>
                {bonus?.wellnessBonusesPla &&
                    bonus.wellnessBonusesPla.map((wellness, index) => {
                        return (
                            <Grid
                                container
                                justify="flex-start"
                                key={index}
                                style={{ marginLeft: '2%' }}
                            >
                                {wellness.wellnessBonusDueDate && (
                                    <>
                                        <Grid item xs={3} lg={3}>
                                            <LabeledValue
                                                label="Due Date"
                                                value={parsStringToDate(
                                                    wellness.wellnessBonusDueDate,
                                                    true
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={3} lg={3}>
                                            <LabeledValue
                                                label="Amount"
                                                value={formatCurrency(wellness.wellnessBonusAmount)}
                                            />
                                        </Grid>
                                    </>
                                )}
                                {bonus.wellnessBonusesSla &&
                                    bonus.wellnessBonusesSla[index]?.wellnessBonusDueDate && (
                                        <>
                                            <Grid item xs={3} lg={3}>
                                                {bonus.wellnessBonusesSla && (
                                                    <LabeledValue
                                                        label="Due Date"
                                                        value={parsStringToDate(
                                                            bonus.wellnessBonusesSla[index]
                                                                .wellnessBonusDueDate,
                                                            true
                                                        )}
                                                    />
                                                )}
                                            </Grid>
                                            <Grid
                                                item
                                                xs={3}
                                                lg={2}
                                                style={{ marginRight: '20px' }}
                                            >
                                                {bonus.wellnessBonusesSla && (
                                                    <LabeledValue
                                                        label="Amount"
                                                        value={formatCurrency(
                                                            bonus.wellnessBonusesSla[index]
                                                                ?.wellnessBonusAmount
                                                        )}
                                                    />
                                                )}
                                            </Grid>
                                        </>
                                    )}
                            </Grid>
                        );
                    })}
            </Grid>
        </React.Fragment>
    );
};
const mapStateToProps = (state: State) => ({
    isReadOnly: state.claimSession.readOnly,
    deathAssessmentDetails: getDeathAssessmentDetails(state).riskPolicyAssessmentDetails,
});

const mapDispatchToProps = {
    openModal: openModalAction,
};

export const DeathBenefitBonusDetails = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(deathBenefitBonusDetails));
